<template>
  <div class="form-group">
    <label>{{ labelText }}</label>
    <a-range-picker
        v-model="dateRange"
        :ranges="presetRanges"
        format="YYYY-MM-DD"
        style="width: 100%"
        @change="onRangeChange"
    /> 
    <!-- Hidden inputs that go with the form -->
    <input type="hidden" :name="`${baseFieldStart}`" :value="hiddenStart">
    <input type="hidden" :name="`${baseFieldEnd}`" :value="hiddenEnd">
  </div>
</template>

<script>
import moment from 'moment';

// Helper function to convert to PST timezone
function toPST(date) {
  if (!date) return null;
  // Convert to PST (UTC-8) - Pacific Standard Time
  return moment(date).utcOffset(-8);
}

export default {
  name: 'AntdRangePicker',
  props: {
    baseFieldStart: { type: String, required: true },
    baseFieldEnd: { type: String, required: true },
    initialStartDate: { type: [String, Date], default: null },
    initialEndDate: { type: [String, Date], default: null },
    labelText: { type: String, default: 'Date Range' },
  },
  data() {
    return {
      dateRange: [],
      hiddenStart: '',
      hiddenEnd: '',
      presetRanges: {
        'Yesterday': [toPST(moment().subtract(1, 'day')), toPST(moment().subtract(1, 'day'))],
        'Last 7 Days': [toPST(moment().subtract(6, 'days')), toPST(moment())],
        'Last 14 Days': [toPST(moment().subtract(13, 'days')), toPST(moment())],
        'Last 30 Days': [toPST(moment().subtract(29, 'days')), toPST(moment())],
        'Last 90 Days': [toPST(moment().subtract(89, 'days')), toPST(moment())],
        'This Month': [toPST(moment().startOf('month')), toPST(moment().endOf('month'))],
        'Last Month': [toPST(moment().subtract(1, 'month').startOf('month')), toPST(moment().subtract(1, 'month').endOf('month'))],
        'All Time': [toPST(moment('2000-01-01')), toPST(moment('2100-01-01'))]
      }
    };
  },
  watch: {
    initialStartDate: 'initializeRange',
    initialEndDate: 'initializeRange',
  },
  mounted() {
    this.initializeRange();
  },
  methods: {
    initializeRange() {
      const start = this.initialStartDate ? toPST(moment(this.initialStartDate, 'YYYY-MM-DD')) : null;
      const end = this.initialEndDate ? toPST(moment(this.initialEndDate, 'YYYY-MM-DD')) : null;
      this.dateRange = start && end ? [start, end] : [];
      this.hiddenStart = start ? start.format('YYYY-MM-DD') : '';
      this.hiddenEnd = end ? end.format('YYYY-MM-DD') : '';
    },
    onRangeChange(dates, dateStrings) {
      const [start, end] = dateStrings;
      this.hiddenStart = start || '';
      this.hiddenEnd = end || '';
      this.$emit('input', {
        [`${this.baseFieldStart}`]: start || null,
        [`${this.baseFieldEnd}`]: end || null
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/AntdDatePicker.vue